import React, { useEffect, useState } from "react";
import { FaPlus, FaSearch, FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";

import { connect } from "react-redux";
import PActions from "../../Stores/redux/Persisted/Actions";
import UnpActions from "../../Stores/redux/Unpersisted/Actions";

import MainLayout from "../Common/MainLayout";
import DataTable from "../../Components/Table/DataTable";
import NewFeedbackQuestionForm from "./NewFeedbackQuestionForm";
import api from "../../Services/Api/api";
import config from "../../Config";

const FeedbackQuestionsScreen = ({
  feedbackQuestions,
  user,
  setScreenState,
}) => {
  const [filteredFeedbackQuestions, setFilteredFeedbackQuestions] = useState(
    []
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    load();
  }, []);

  // Filter & Search Logic
  useEffect(() => {
    let filtered = feedbackQuestions.map((x) => ({
      ...x,
      officeTypeName: x.officeType?.name,
      officeCategoryName: x.officeType?.category?.name,
      optionList: x.options?.join(", "),
      responseType: config.feedbackQuestionTypes.find(
        (y) => y.value === x.responseType
      )?.label,
      active: x.active ? <span>✅</span> : <span>❌</span>,
    }));

    if (searchTerm) {
      filtered = filtered.filter((feedbackQuestion) =>
        feedbackQuestion.question
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      );
    }

    setFilteredFeedbackQuestions(filtered);
  }, [searchTerm, feedbackQuestions]);

  const load = async () => {
    setLoading(true);
    try {
      const { feedbackQuestions } = await api.get(
        "v1/district-admin/feedback-question",
        {
          filter: JSON.stringify({
            where: { district: user.district._id },
            populate: [
              {
                path: "officeType",
                select: "name category",
                populate: [
                  {
                    path: "category",
                    select: "name",
                  },
                ],
              },
            ],
            sortby: "createdAt",
            order: -1,
          }),
        }
      );
      console.log({ feedbackQuestions });
      setScreenState({ feedbackQuestions });
    } catch (e) {
      console.error(e);
      toast.error(e.message);
    }
    setLoading(false);
  };

  const columns = [
    { label: "Office Type", accessor: "officeTypeName" },
    { label: "Office Category", accessor: "officeCategoryName" },
    { label: "Question", accessor: "question" },
    { label: "Answer Type", accessor: "responseType" },
    { label: "Options", accessor: "optionList" },
    { label: "Active", accessor: "active" },
  ];

  return (
    <MainLayout screenName="feedbackQuestions">
      <main className="feedback-questions-screen">
        {/* Page Title & Actions */}
        <div className="page-header">
          <h1>
            Feedback Questions{" "}
            {loading ? <FaSpinner className="spinner" /> : null}
          </h1>
          <button className="add-btn" onClick={() => setShowModal(true)}>
            <FaPlus /> Add New Question
          </button>
        </div>

        <div className="filters">
          <div className="search-bar">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* Table */}
        <DataTable
          columns={columns}
          data={filteredFeedbackQuestions}
          searchable={false}
          emptyList={loading ? "Loading Data" : null}
        />

        {/* Modal for New FeedbackQuestion */}
        <NewFeedbackQuestionForm
          key={(!!showModal).toString()}
          {...{
            isOpen: showModal,
            onClose: () => setShowModal(false),
            onSuccess: () => load(),
          }}
        />
      </main>
    </MainLayout>
  );
};

const SCREEN_NAME = "FEEDBACK_QUESTIONS_SCREEN";

const mapStateToProps = (state) => ({
  feedbackQuestions: state.vState[SCREEN_NAME]?.feedbackQuestions || [],
  user: state.pState.AUTH.user,
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FeedbackQuestionsScreen);
